import axios from "axios";
import apiEndpoints from "../config/apiEndpoints";
import { fetchData } from "../utils/utils";

const FetchWebshopSettings=async(key)=>{
    try {
        const response=await axios.get(apiEndpoints?.GET_WEBSHOP_WIDGET_SETTINGS(key));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}

const FetchDeliverySlots=async(key)=>{
    try {
        const response=await axios.get(apiEndpoints?.GET_DELIVERY_SLOTS(key));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}

const FetchWebShopCategories=async(key,lang,id)=>{
    try {
        const response=await axios.get(apiEndpoints?.GET_WEBSHOP_CATEGORIES(key,lang,id));
        return response
        
    } catch (error) {
        console.error("Error fetching webshop categories", error);
        return null;    
    }
}

const FetchWebShopProductList=async(key,lang,categoryId)=>{
    try {
        const response=await axios.get(apiEndpoints?.GET_WEBSHOP_PRODUCTSLIST(key,lang,categoryId));
        return response
        
    } catch (error) {
        console.error("Error fetching webshop productlist", error);
        return null;    
    }
}

const FetchWebshopProductsInfo=async(key,lang,productId)=>{
    try {
        const response=await axios.get(apiEndpoints?.GET_WEBSHOP_PRODUCT_DETAILS(key,lang,productId));
        return response   
    } catch (error) {
        console.error("Error fetching webshop products info", error);
        return null;    
    }
}

const CreateWebShopOrder=async(data)=>{
    try {
        const response=await axios.post(apiEndpoints?.CREATE_WEBSHOP_ORDER,data);
        return response      
    } catch (error) {
        console.error("Error creating webshop order", error);
        return null;
    }
}

const createGuest=async(payload)=>{
    try {
        const response=await axios.post(apiEndpoints?.CREATE_GUEST,payload);
        return response      
    } catch (error) {
        console.error("Error creating guest", error);
        return null;
    }
}
export const getWebshopOpeningHours = async (date,key) => {
    // Ensure all required parameters are provided
    const endpoint = apiEndpoints.GET_WEBSHOP_OPENINGHOURS(date,key);
    const result = await fetchData({ endpoint, method: "GET"});
    return result;
  };

export const getCurrencyData = async (key) => {
    // Ensure all required parameters are provided
    const endpoint = apiEndpoints.CURRENCY_ENDPOINT(key);
    const result = await fetchData({ endpoint, method: "GET"});
    return result;
  };
  

  export const getWebshopFields = async (key,lang) => {
    // Ensure all required parameters are provided
    const endpoint = apiEndpoints.GET_WEBSHOP_FIELDS(key,lang);
    const result = await fetchData({ endpoint, method: "GET"});
    return result;
  };
export {
    FetchWebShopCategories,
    FetchWebShopProductList,
    FetchWebshopProductsInfo,
    CreateWebShopOrder,
    FetchWebshopSettings,
    createGuest,
    FetchDeliverySlots
}
